import ApiClient from "@/api/ApiClient";
import { MemoruHomeResourceDownloadResponse } from "@API/src/component/memoruHome/resource/types";
import { PostResourceDownloadRequest } from "@/model/request/resource";
import { isTypeMemoruHomeResourceDownloadResponse } from "@/model/typeGuard/resource";

export default class ApiResource {
  public static async postResourceDownload(
    request: PostResourceDownloadRequest
  ): Promise<MemoruHomeResourceDownloadResponse> {
    const response = await ApiClient.post(`/resource/download-url`, request);
    if (isTypeMemoruHomeResourceDownloadResponse(response)) {
      return response;
    }
    throw response;
  }
}
